export default __webpack_public_path__ + "static/methodBackground-bd77180167f6fdf38c69867fc0d77a21.jpg";